import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';
import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { ExtendedDosage, PreciseDosageUnit } from '~libs.shared.prescription';

import { CreateExtendedDosageLink } from '../../prescription/extendedDosage/CreateExtendedDosageLink';
import { ExtendedDosageStagesSummary } from '../../prescription/extendedDosage/ExtendedDosageStagesSummary';
import { NumericalDosage } from '../../prescription/numericalDosage/NumericalDosage';
import { DraftPrescriptionsFormController } from '../DraftPrescriptionsForm.types';

import { DraftStandardPrescriptionFieldName } from './DraftStandardPrescriptionField.types';

type DraftStandardPrescriptionDosageSlotProps = Pick<
   DraftPrescriptionsFormController,
   'register' | 'trigger' | 'setValue' | 'setError' | 'formState' | 'watch'
> & {
   readonly index: number;
   readonly extendedDosageFieldName: DraftStandardPrescriptionFieldName;
   readonly dosageFieldName: DraftStandardPrescriptionFieldName;
   readonly dosage: string | null;
   readonly extendedDosage: ExtendedDosage | null;
   readonly extendedDosageActive: boolean;
   readonly required: boolean;
   readonly dosageFrequencyNotAllowed: boolean;
   readonly initialNumericalDosageFrequency: number | null;
   readonly initialNumericalDosageQuantity: number | null;
   readonly initialDosageUnit: PreciseDosageUnit | null;
   readonly medicine: MedicineSimple;
   readonly reimbursements: PatientMedicine['reimbursements'];
   readonly dosageFrequencyValidated: boolean;
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const DraftStandardPrescriptionDosageSlot = (props: DraftStandardPrescriptionDosageSlotProps): JSX.Element => {
   if (props.extendedDosageActive && props.extendedDosage) {
      return (
         <ExtendedDosageStagesSummary
            setValue={props.setValue}
            name={props.extendedDosageFieldName}
            dosageFieldName={props.dosageFieldName}
            dosage={props.dosage}
            extendedDosage={props.extendedDosage}
            medicine={props.medicine}
            reimbursements={props.reimbursements}
            dosageFrequencyValidated={props.dosageFrequencyValidated}
            visitDiagnoses={props.visitDiagnoses}
         />
      );
   }

   return (
      <NumericalDosage
         register={props.register}
         trigger={props.trigger}
         setValue={props.setValue}
         setError={props.setError}
         formState={props.formState}
         watch={props.watch}
         index={props.index}
         required={props.required}
         dosageFrequencyNotAllowed={props.dosageFrequencyNotAllowed}
         initialNumericalDosageFrequency={props.initialNumericalDosageFrequency}
         initialNumericalDosageQuantity={props.initialNumericalDosageQuantity}
         initialDosageUnit={props.initialDosageUnit}
         medicine={props.medicine}
         labelAction={
            <CreateExtendedDosageLink
               setValue={props.setValue}
               name={props.extendedDosageFieldName}
               dosageFieldName={props.dosageFieldName}
               dosage={props.dosage}
               extendedDosage={props.extendedDosage}
               medicine={props.medicine}
               reimbursements={props.reimbursements}
               dosageFrequencyValidated={props.dosageFrequencyValidated}
               visitDiagnoses={props.visitDiagnoses}
            />
         }
      />
   );
};
